import { useTheme } from "@emotion/react";
import { Box, Button, Grid, useMediaQuery } from "@mui/material";
import { H6, H7, Small } from "components/Typography";
import { useState } from "react";
// import ArrowForwardIosSharp from "@mui/icons-material/ArrowForwardIosSharp";
import FlexBox from "components/flexbox/FlexBox";
import AppAvatar from "components/avatars/AppAvatar";
import avatar3 from "assets/avatar-3.png";
import ThumbsUpButton from "./ThumbsUpButton";
import CreateCommentBox from "./CreateCommentBox";

export default function Comment({ item }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showCommentBox, setShowCommentBox] = useState(false);

  return (
    <Grid
      container
      direction="row"
      justifyContent={"center"}
      alignItems={"center"}
      sx={{
        borderBottom: "1px solid #E1E1E1",
        padding: "1rem 1rem",
        backgroundColor: "#ffffff",
      }}
    >
      <Grid
        container
        direction={"row"}
        mt={0.5}
        mb={0.5}
        px={isMobile ? 2 : 0}
        py={isMobile ? 1 : 0}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          flexWrap: isMobile ? "inherit" : "nowrap",
        }}
      >
        <Grid
          mb={isMobile ? 2 : 0}
          item
          sx={{ display: "flex", justifyContent: "flex-start" }}
        >
          <FlexBox
            gap={1.2}
            alignItems="flex-start"
            sx={{ justifyContent: "flex-start" }}
          >
            <AppAvatar
              alt={"avatar"}
              src={avatar3}
              style={{ width: "42px", height: "42px" }}
            />
            <FlexBox flexDirection="column">
              <FlexBox flexDirection="row">
                <H6 sx={{ fontWeight: 600 }}>{item.writer}</H6>
                <Small mb={0.5} ml={1}>
                  {item.date}
                </Small>
              </FlexBox>
              <H6
                style={{
                  marginLeft: 0,
                  paddingLeft: 0,
                  textAlign: "left",
                }}
              >
                {item.comment}
              </H6>
            </FlexBox>
          </FlexBox>
        </Grid>

        <Grid
          ml={isMobile ? 5 : 0}
          item
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Grid item ml={1}>
            <ThumbsUpButton />
          </Grid>

          <Grid item ml={1.5}>
            <Button
              onClick={() => setShowCommentBox(!showCommentBox)}
              variant="outlined"
              size="small"
              sx={{
                justifyContent: "center",
                alignItems: "center",
                height: "34px",
                fontSize: 15,
                color: "primary.grey2",
                borderRadius: 2,
                maxWidth: 110,
                fontWeight: 500,
                whiteSpace: "nowrap",
                minWidth: "fit-content",
                padding: "0.6rem 0.8rem",
              }}
            >
              답글 쓰기
            </Button>
          </Grid>

          <Grid
            item
            ml={1.5}
            sx={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {item.delete ? (
              <H7
                style={{
                  alignSelf: "center",
                  color: theme.palette.primary.red,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                삭제
              </H7>
            ) : (
              <H7
                style={{
                  alignSelf: "center",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                신고
              </H7>
            )}
          </Grid>
        </Grid>
      </Grid>

      {showCommentBox && (
        <Box mb={1} mt={2} sx={{ width: "100%" }}>
          <CreateCommentBox
            smallBox={true}
            setShowCommentBox={setShowCommentBox}
          />
        </Box>
      )}
    </Grid>
  );
}
